import React from 'react';

import {
  CloseIcon,
  CmButton,
  CmModal,
  CmModalBody,
  CmModalFooter,
  CmText,
  SendIcon,
} from '@/components/uiParts';
import {
  CANCEL_BUTTON_BG,
  DetailMode,
  RESEND_BUTTON_BG,
  RESEND_BUTTON_HOVER_BG,
} from '@/pages/externals/mos-pos-resend/service';

type Props = {
  mode: DetailMode;
  webOrderId: string;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onExecute: () => void;
};

/** 再送信 / 取消の実行確認モーダル。文言とボタン色以外は共通。 */
export const ActionConfirmModal: React.VFC<Props> = ({
  mode,
  webOrderId,
  isOpen,
  isSubmitting,
  onClose,
  onExecute,
}) => {
  const isResend = mode === 'resend';

  return (
    <CmModal
      title={isResend ? '再送信の確認' : '注文の取消'}
      headerSize="md"
      size="lg"
      isCentered
      // 本文が数行しかないため、スクロールバーを常時表示させない
      contentOverflowY="auto"
      // 誤操作防止のためオーバーレイクリックでは閉じない
      closeOnOverlayClick={false}
      {...{ isOpen, onClose }}
    >
      <CmModalBody>
        {isResend ? (
          <>
            <CmText mb="8px">
              {`WebオーダーID ${webOrderId} をPOS中継サーバーへ再送信します。`}
            </CmText>
            <CmText>再送信しますが、よろしいですか？</CmText>
          </>
        ) : (
          <>
            <CmText mb="8px">{`WebオーダーID ${webOrderId} を取消します。`}</CmText>
            <CmText mb="8px">
              ※「取消」後も、フードデリバリーサービス側の注文はキャンセルされません。
            </CmText>
            <CmText>取消しますが、よろしいですか？</CmText>
          </>
        )}
      </CmModalBody>
      <CmModalFooter>
        <CmButton
          variant="outline"
          mr={4}
          disabled={isSubmitting}
          onClick={onClose}
        >
          キャンセル
        </CmButton>
        {isResend ? (
          // @ts-ignore TS2590
          <CmButton
            bg={RESEND_BUTTON_BG}
            color="white"
            _hover={{ bg: RESEND_BUTTON_HOVER_BG }}
            isLoading={isSubmitting}
            disabled={isSubmitting}
            leftIcon={<SendIcon boxSize={3} />}
            onClick={onExecute}
          >
            再送信する
          </CmButton>
        ) : (
          // @ts-ignore TS2590
          <CmButton
            colorScheme="red"
            bg={CANCEL_BUTTON_BG}
            isLoading={isSubmitting}
            disabled={isSubmitting}
            leftIcon={<CloseIcon boxSize={2.5} />}
            onClick={onExecute}
          >
            取消する
          </CmButton>
        )}
      </CmModalFooter>
    </CmModal>
  );
};
